//This function is for adding in deadline:: to the queue DURING A TURN that a deadline is set.
//Start Turn Series already provides known deadlines at the beginning of a turn.

export function getUpdatedQueueWithDeadline(currentQueue=[], combatantSelectingAction, combatants) {

  if (!currentQueue.length) {
    return []; //Fallback incase our queue is not populated yet
  }

  //Return a copy of the list with deadlines in place (will replace any already known deadline entries)
  return currentQueue.map(id => {
    const combatantModel = combatants[id];

    if (id.match(/^deadline::/)) {
      return null; //Take this instance of deadline out. Don't worry! We will replace it.
    }

    if (!combatantModel) {
      //Probably from the cloudQueue. Just return this one.
      return [id];
    }

    if (combatantModel.status === "deadline") {
      return [
        id, //If we have a deadline, provide both my ID and then my deadline turn
        `deadline::${id}`
      ]
    }

    return [id]

  }).filter(d => Boolean(d)).reduce((a,b) => { //Remove any null values and return 1 array
    return [...a, ...b]
  });

}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-updated-queue-with-deadline.js